/**
 * SurveyJS has no native row/panel-count function; native countInArray skips
 * empty just-added entries. Used to lock existing entries in dynamic panels
 * via enableIf "{panelIndex} >= arrayLength({panelName}) - 1" (see
 * schemas/ctm-schema.json remarks panel and docs/matrix-lock-existing-rows-plan.md).
 * NOTE: {panelIndex} is 0-based in expressions (survey-core 2.3.6) — the
 * "starts with 1" doc covers titles only.
 */
const arrayLength = (params: unknown[]): number => {
  const arr = params[0];
  return Array.isArray(arr) ? arr.length : 0;
};

export default arrayLength;
